import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/style.css";
import { useNavigate } from "react-router-dom";
import refreshIcon from "../assets/img/CaptchaRefresh.png"; // Import the refresh icon image
import { encryptData } from "../api/encryption";
import { post } from "../api/services";
import { API_ENDPOINTS } from "../api/endpoints";
import { Toast } from "bootstrap";

const generateCaptcha = () => {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let captcha = "";
  for (let i = 0; i < 8; i++) {
    captcha += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return captcha;
};

const LoginForm = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [captcha, setCaptcha] = useState(generateCaptcha());
  const [captchaInput, setCaptchaInput] = useState("");
  const [error, setError] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    // Push current state to history so forward is not available
    navigate(null, "", window.location.href);
    sessionStorage.setItem("isLoggedIn", "false");

    const handlePopState = (event) => {
      // If user tries to go forward, push them back to login
      if (!window.location.hash && !window.location.search) {
        navigate("/", { replace: true });
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  const showError = (inputName, message) => {
    setError((prevError) => ({ ...prevError, [inputName]: message }));
  };

  const showSuccess = (inputName) => {
    setError((prevError) => ({ ...prevError, [inputName]: "" }));
  };

  const isValidUsername = (value) => /^[a-zA-Z0-9_.@]{4,32}$/.test(value); // Only allow letters, numbers, _, ., @, 4-32 chars
  //const isValidPassword = (value) => /^[\w!@#$%^&*()-+=]{6,32}$/.test(value); // Only allow safe characters, 6-32 chars

  const checkRequired = (inputName, value) => {
    if (!value.trim()) {
      showError(
        inputName,
        `Enter valid ${inputName.charAt(0).toUpperCase() + inputName.slice(1)}`
      );
      return false;
    }
    if (inputName === "username" && !isValidUsername(value)) {
      showError(inputName, "Username contains invalid characters.");
      return false;
    }
    // if (inputName === "password" && !isValidPassword(value)) {
    //   showError(inputName, "Password contains invalid characters.");
    //   return false;
    // }
    showSuccess(inputName);
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validUsername = checkRequired("username", username);
    //const validPassword = checkRequired("password", password);
    const validCaptcha = checkRequired("captchaInput", captchaInput);

    if (!validUsername || !validCaptcha) return;

    if (captchaInput === captcha) {
      const encryptedusername = encryptData(username);
      const encryptedpassword = encryptData(password);
      try {
        const loginResponse = await post(API_ENDPOINTS.LOGIN, {
          username: encryptedusername,
          password: encryptedpassword,
        });
        if (
          loginResponse.status == 200 &&
          loginResponse.data.action_response === "Approved"
        ) {
          // After successful login
          sessionStorage.setItem("isLoggedIn", "true"); // Store login status
          navigate("/customerscreen", { replace: true });
        } else {
          Toast("Login failed. Please check your credentials.");
        }
      } catch (error) {
        showError(
          "captchaInput",
          "Login failed. Please check your credentials."
        );
      } finally {
        handleRefreshCaptcha();
      }
    } else {
      handleRefreshCaptcha();
      showError("captchaInput", "Captcha does not match");
    }
  };

  const handleReset = () => {
    setUsername("");
    setPassword("");
    setCaptcha(generateCaptcha());
    setCaptchaInput("");
    setError({});
  };

  const handleRefreshCaptcha = () => {
    setCaptcha(generateCaptcha());
    setCaptchaInput("");
  };

  return (
    <div className="form_box">
      <form
        id="form"
        className="form"
        autoComplete="off"
        onSubmit={handleSubmit}
        onReset={handleReset}
      >
        <div className="container-fluid">
          <div className="heading">
            <p>
              Indus <span>Self Sales Assist</span> Login
            </p>
            <h3>Welcome Back!!</h3>
          </div>
          <div className="row">
            {/* Username Field */}
            <div className="col-md-12 mb-4">
              <div className="custom_filed">
                <div className={`form-group ${error.username ? "error" : ""}`}>
                  <label htmlFor="username">
                    Username<span style={{ color: "#98272A" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Username"
                    id="username"
                    autoComplete="off"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                  {error.username && (
                    <small className="text-danger">{error.username}</small>
                  )}
                </div>
              </div>
            </div>

            {/* Password Field */}
            <div className="col-md-12 mb-4">
              <div className="custom_filed">
                <div className={`form-group ${error.password ? "error" : ""}`}>
                  <label htmlFor="password">
                    Password<span style={{ color: "#98272A" }}>*</span>
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Enter Password"
                    id="password"
                    autoComplete="off"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  {error.password && (
                    <small className="text-danger">{error.password}</small>
                  )}
                </div>
              </div>
            </div>

            {/* Captcha Field */}
            <div className="col-md-12 mb-4">
              <div className="custom_filed">
                <div
                  className={`form-group ${error.captchaInput ? "error" : ""}`}
                >
                  <label htmlFor="captcha_input">
                    Captcha<span style={{ color: "#98272A" }}>*</span>
                  </label>
                  <div
                    style={{
                      flexDirection: "row",
                      display: "flex",
                      gap: 10,
                      alignItems: "center",
                    }}
                  >
                    <input
                      type="text"
                      placeholder="Enter Captcha"
                      id="captcha_input"
                      value={captchaInput}
                      onChange={(e) => setCaptchaInput(e.target.value)}
                      onCopy={(e) => e.preventDefault()}
                      onPaste={(e) => e.preventDefault()}
                      onCut={(e) => e.preventDefault()}
                    />
                    <div
                      className="input-group-append"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <span
                        className="input-group-text"
                        style={{
                          backgroundColor: "#ECECEC",
                          fontSize: "18px",
                          fontWeight: "bold",
                          letterSpacing: "2px",
                          height: "50px",
                          borderRadius: 10,
                          userSelect: "none", // Prevent text selection
                        }}
                        onCopy={(e) => e.preventDefault()}
                        onPaste={(e) => e.preventDefault()}
                        onCut={(e) => e.preventDefault()}
                        onDragStart={(e) => e.preventDefault()}
                        onDrop={(e) => e.preventDefault()}
                      >
                        {captcha}
                      </span>
                      <div
                        style={{ marginLeft: "10px" }}
                        type="button"
                        className="btn btn-link p-0"
                        onClick={handleRefreshCaptcha}
                      >
                        <img
                          src={refreshIcon}
                          alt="Refresh Captcha"
                          style={{ width: "24px", height: "24px" }}
                        />
                      </div>
                    </div>
                  </div>
                  {error.captchaInput && (
                    <small className="text-danger">{error.captchaInput}</small>
                  )}
                </div>
              </div>
            </div>

            {/* Buttons */}
            <div className="col-md-12 mt-2">
              <div className="row">
                <div className="col-md-12 col-6 col-lg-6">
                  <div className="custom_filed_process">
                    <button type="reset" className="process w-100 reset">
                      Reset
                    </button>
                  </div>
                </div>
                <div className="col-md-12 col-6 col-lg-6">
                  <div className="custom_filed_process">
                    <button type="submit" className="process w-100">
                      Click to Proceed
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default LoginForm;
